

export const Icons: Record<string, JSX.Element | string> = {};
